import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';
import { cn } from '@/lib/utils';

type FooterProps = {
  children: React.ReactNode;
  classNames?: {
    wrapper?: string;
  };
};

export default function Footer({ classNames, children }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer
        className={cn(
          'bg-neutral-N99 light text-neutral-N00 flex justify-center px-5 py-8 sm:py-[3.75rem]',
          classNames?.wrapper
        )}
        data-tracker-section='footer'
        data-tracker-component='footer'
      >
        <div className='w-full max-w-5xl'>{children}</div>
      </footer>
      <div className='text-neutral-N50 light bg-neutral-N94 text-body-s py-4 text-center'>
        © 2018-{currentYear} {currentLocaleConfig().footerAllRightsReserved}
      </div>
    </>
  );
}
